<template>
  <v-container class="screen2 tr">
    <div id="trainings"></div>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <h1>Наши услуги</h1>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center>
      <v-flex xs12 sm12 md4
      v-for="service in services"
      :key="service.id"
      >
        <router-link :to="{ path: service.url }">
          <div class="tr-block">
            <v-img :src="service.img"></v-img>
            <div class="tr-h1">
              {{ service.offer }}
            </div>
            <v-btn color="rgb(16, 148, 12)" large flat>Подробнее</v-btn>
          </div>
        </router-link>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
export default {
  data () {
    return {
      services: [
        {
          id: 1,
          url: '/malina/rooms',
          img: '/static/img/services/malina/1.jpg',
          offer: 'Аренда номеров'
        },
        {
          id: 2,
          url: '/malina/hammams',
          img: '/static/img/services/malina/2.jpg',
          offer: 'Сауны и хаммам'
        }
        /*
        {
          id: 3,
          url: '/malina/hammams',
          img: '/static/img/services/malina/3.jpg',
          offer: 'Сауна без бассейна'
        },
        {
          id: 4,
          url: '/malina/hammams',
          img: '/static/img/services/malina/4.jpg',
          offer: 'Хаммам'
        },
        {
          id: 5,
          url: '/malina/hammams',
          img: '/static/img/services/malina/5.jpg',
          offer: 'Бильярд'
        },
        {
          id: 6,
          url: '/malina/hammams',
          img: '/static/img/services/malina/6.jpg',
          offer: 'Караоке'
        }
        */
      ]
    }
  }
}
</script>

<style scoped>
#trainings {
  position: relative;
  top: -90px;
}

a,
a:hover,
a:visited,
a:active {
    text-decoration: none;
}

.tr h1 {
  margin-bottom: 50px;
}

.tr-block {
  margin: 15px;
  border-radius: 5px;
  border: 1px solid #c3c3c3;
  text-align: center;
}

.tr-block:hover {
  opacity: 0.9;
}

.tr-h1 {
  font-size: 23px;
  font-weight: 900;
  color: #000000;
  margin: 15px 0px 0px 0px;
  /*border-right: 1px solid #FFFFFF;*/
}

.tr-h2 {
  margin-top: 10px;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .tr h1 {
    margin-bottom: 30px;
  }

  .tr-h1 {
    font-size: 19px;
  }
}

/* SMALL */
@media (max-width: 960px) {

}

</style>



// WEBPACK FOOTER //
// src/components/screens/malina/Services.vue